"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NextAuthority = void 0;

var _Struct = _interopRequireDefault(require("../codec/Struct"));

var _Tuple = _interopRequireDefault(require("../codec/Tuple"));

var _Vector = _interopRequireDefault(require("../codec/Vector"));

var _U = _interopRequireDefault(require("../primitive/U64"));

var _BlockNumber = _interopRequireDefault(require("./BlockNumber"));

var _SessionKey = _interopRequireDefault(require("./SessionKey"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name NextAuthority
 * @description
 * The next authority available as [[SessionKey]]
 */
class NextAuthority extends _Tuple.default {
  constructor(value) {
    super({
      SessionKey: _SessionKey.default,
      U64: _U.default
    }, value);
  }

  get index() {
    return this[1];
  }

  get sessionKey() {
    return this[0];
  }

}
/**
 * @name StoredPendingChange
 * @description
 * Stored pending change for a Grandpa events
 */


exports.NextAuthority = NextAuthority;

class StoredPendingChange extends _Struct.default {
  constructor(value) {
    super({
      scheduledAt: _BlockNumber.default,
      delay: _BlockNumber.default,
      nextAuthorities: _Vector.default.with(NextAuthority)
    }, value, new Map([['scheduledAt', 'scheduled_at'], ['nextAuthorities', 'next_authorities']]));
  }

  get delay() {
    return this.get('delay');
  }

  get nextAuthorities() {
    return this.get('nextAuthorities');
  }

  get scheduledAt() {
    return this.get('scheduledAt');
  }

}

exports.default = StoredPendingChange;